import { srand } from '../../../CodesThatsGottaGoSomewhereElse';
import { Component, component, property } from '../../../concepts/objects';
import { ColorGroup } from '../../../ui';

const tagDef = {
    name: 'Tag',
};

@component(tagDef)
export class Tag extends Component {

    public static sort(tags: Tag[]) {
        return tags.sort((a, b) => b?.name?.localeCompare(a?.name));
    }

    public static pickColor(name: string) {
        const a = Array.from(Object.values(ColorGroup.default).slice(0, 20));
        const r = srand(name);
        return a[Math.floor(r * a.length)];
    }

    @property({ type: 'string', default: '' })
    public name!: string;

    @property({ type: 'string', default: '' })
    public value!: string;

    @property({ type: 'string', default: '' })
    public color!: string;

    @property({ type: 'string', default: '' })
    public symbol!: string;

    public get text() {
        if (!this.name && !this.value) return '...';
        return [this.symbol, this.value || this.name].filter(x => !!x).join(' ').toUpperCase();
    }
}
